const SECTIONS = [
  {
    title: "1. Qu'est-ce qu'un cookie ?",
    paras: [
      "Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, téléphone) lors de la consultation d'un site internet. Il permet au site de mémoriser certaines informations relatives à votre visite, afin de faciliter la navigation et d'améliorer votre expérience utilisateur.",
      "Les cookies peuvent être déposés par le site que vous visitez (cookies « internes ») ou par des services tiers utilisés par ce site (cookies « tiers »).",
    ],
  },
  {
    title: "2. Cookies utilisés par Labounite",
    paras: [
      "Le site labounite.fr utilise uniquement des cookies strictement nécessaires au bon fonctionnement du site. Aucun cookie publicitaire, de profilage ou de pistage n'est utilisé.",
    ],
    subsections: [
      {
        subtitle: "Cookies strictement nécessaires",
        paras: [
          "Ces cookies sont indispensables au fonctionnement du site et ne peuvent pas être désactivés. Ils permettent notamment :",
          { list: [
            "La gestion de votre session de connexion (authentification)",
            "Le fonctionnement du panier d'achat",
            "La mémorisation de vos préférences en matière de cookies (votre choix d'acceptation ou de refus)",
            "La sécurisation du paiement via Stripe",
          ] },
          "Ces cookies ne collectent aucune donnée à des fins de marketing ou de publicité.",
        ],
      },
      {
        subtitle: "Cookies d'analyse d'audience (optionnels)",
        paras: [
          "Le site peut, le cas échéant, utiliser des cookies de mesure d'audience anonymisée pour comprendre comment les visiteurs naviguent sur le site et améliorer son contenu.",
          "Si de tels cookies sont mis en place à l'avenir, ils ne seront activés qu'après recueil de votre consentement préalable.",
          "À ce jour, aucun cookie d'analyse d'audience n'est utilisé sur le site.",
        ],
      },
    ],
  },
  {
    title: "3. Durée de conservation des cookies",
    paras: [
      "Les cookies strictement nécessaires ont une durée de vie limitée à la session de navigation ou, pour les cookies de préférences, à une durée maximale de 12 mois.",
      "Le cookie de mémorisation de votre choix en matière de consentement est conservé pendant 6 mois. À l'expiration de ce délai, le bandeau de consentement vous sera présenté à nouveau.",
    ],
  },
  {
    title: "4. Gestion de vos préférences",
    paras: [
      "Lors de votre première visite sur le site, un bandeau d'information vous permet d'accepter ou de refuser les cookies optionnels.",
      "Vous pouvez modifier vos préférences à tout moment en cliquant sur le lien « Gérer les cookies » situé en bas de cette page ou dans le pied de page du site.",
      "Vous pouvez également configurer votre navigateur pour accepter ou refuser les cookies. Voici les liens vers les pages d'aide des principaux navigateurs :",
      { list: [
        "Google Chrome : chrome://settings/cookies",
        "Mozilla Firefox : about:preferences#privacy",
        "Safari : Préférences > Confidentialité",
        "Microsoft Edge : edge://settings/privacy",
      ] },
      "Attention : la désactivation des cookies strictement nécessaires peut empêcher le bon fonctionnement de certaines fonctionnalités du site (connexion, panier, paiement).",
    ],
  },
  {
    title: "5. Cookies tiers",
    paras: [
      "Le site utilise le service de paiement Stripe pour le traitement sécurisé des paiements. Stripe peut déposer ses propres cookies techniques nécessaires au bon déroulement de la transaction.",
      "Pour en savoir plus sur la politique de cookies de Stripe, consultez : https://stripe.com/fr/cookie-settings",
      "Aucun autre service tiers déposant des cookies n'est actuellement utilisé sur le site.",
    ],
  },
  {
    title: "6. Vos droits",
    paras: [
      "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition concernant les données collectées via les cookies.",
      "Pour exercer vos droits ou pour toute question relative aux cookies, vous pouvez contacter :",
      { list: [
        "E-mail : labounite@gmail.com",
        "Adresse postale : 13 lieu dit Chapsieres 15380 Anglards de Salers",
      ] },
      "Vous pouvez également introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) : www.cnil.fr",
    ],
  },
  {
    title: "7. Mise à jour de cette politique",
    paras: [
      "La présente politique de cookies peut être modifiée à tout moment afin de refléter les évolutions du site ou de la réglementation applicable.",
      "La date de dernière mise à jour est indiquée en haut de cette page.",
      "En cas de modification significative, une nouvelle demande de consentement pourra vous être adressée.",
    ],
  },
];

const Para = ({ p }) =>
  typeof p === "string" ? (
    <p className="leading-relaxed text-[#1F1C18]/85">{p}</p>
  ) : (
    <ul className="space-y-1.5 pl-5 list-disc marker:text-terracotta text-[#1F1C18]/85">
      {p.list.map((li) => <li key={li}>{li}</li>)}
    </ul>
  );

const SubSection = ({ sub }) => (
  <div className="space-y-2 mt-4">
    <h3 className="font-serif-display text-lg text-[#1F1C18]/90">{sub.subtitle}</h3>
    {sub.paras.map((p, i) => <Para key={i} p={p} />)}
  </div>
);

export default function CookiePolicy() {
  const resetConsent = () => {
    localStorage.removeItem("cookie_consent");
    window.location.reload();
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-testid="cookie-policy-page">
      <p className="font-accent text-3xl text-terracotta -rotate-2 mb-2">Labounite</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mb-3">Politique de cookies</h1>
      <p className="text-sm text-[#6B655C] mb-10" data-testid="cookie-policy-updated">Dernière mise à jour : octobre 2026</p>
      <div className="bg-white/70 backdrop-blur-md rounded-3xl p-6 sm:p-10 space-y-10">
        {SECTIONS.map((s) => (
          <section key={s.title} className="space-y-3">
            <h2 className="font-serif-display text-2xl text-terracotta">{s.title}</h2>
            {s.paras && s.paras.map((p, i) => <Para key={i} p={p} />)}
            {s.subsections && s.subsections.map((sub) => (
              <SubSection key={sub.subtitle} sub={sub} />
            ))}
          </section>
        ))}

        <section className="pt-6 border-t border-[#E5E1D8]">
          <button
            onClick={resetConsent}
            className="text-sm text-terracotta underline hover:text-terracotta/80 transition"
            data-testid="cookie-reset-consent-btn"
          >
            Gérer les cookies — Réinitialiser mes préférences
          </button>
        </section>
      </div>
    </div>
  );
}
